import React from 'react'

import './About.css'

export default function About() {
    return (
        <div className="about-container">
            <h1 className="about-heading">About</h1>
            <div className="about-main">
                <p className="about-content">
                   <p> This is an realtime AI based Yoga Trainer which detects your pose how well you are doing it.
                   </p>
                   <p>

                    By using this app people can correct themselfs and have a clear body posture while performing different yoga poses.                    
                    
                   </p>
                   <p>

                   
                    This AI first predicts keypoints or coordinates of different parts of the body(basically where
                    they are present in an image) and then it use another classification model to classify the poses.
                    </p>
                    <p>

                     If 
                    someone is doing a pose correctly (about 95% Accurate) then AI detects that pose and it will notify you by making virtual skeleton green and sounds. 
                    </p>
                    <p>

                    The model which is detecting the points is basically a Tensorflow pretrained Movenet Model To Predict the 
                    Keypoints and building a neural network top of that which uses these coordinates and classify a yoga pose.
                    </p>
                        <p>
                    The model is then trained in python because of tensorflowJS we can leverage the support of browser so as to convert
                            
                    the keras/tensorflow model to tensorflowJS and use in for proper prediction.
                        </p>
                </p>
                
            </div>
        </div>
    )
}
